import { isInRange } from '../../utils';
import { EMPTY_SELECTIONRANGE } from '../models';
import { getDate } from '@progress/kendo-date-math';
var calculateValue = function (min, max, stateValue, propValue) {
    return propValue !== undefined
        ? propValue !== null && isInRange(propValue, min, max)
            ? propValue
            : null
        : stateValue !== null && isInRange(stateValue, min, max)
            ? stateValue
            : null;
};
var extractDateFromValue = function (min, max, value) {
    return value instanceof Date && !Array.isArray(value) && isInRange(getDate(value), min, max)
        ? getDate(value)
        : null;
};
var extractMultipleFromValue = function (min, max, value) {
    return Array.isArray(value)
        ? value.filter(function (date) { return isInRange(date, min, max); }).map(function (date) { return getDate(date); })
        : null;
};
var extractRangeFromValue = function (value) {
    return typeof value === 'object' && !(value instanceof Date) && value !== null && !Array.isArray(value)
        ? value
        : EMPTY_SELECTIONRANGE;
};
var extractFocusedDate = function (single, multiple, range) {
    return single || (multiple && multiple[0]) || (range && range.start);
};
var extractActiveRange = function (range, single) {
    return range.start === null && single === null
        ? 'start'
        : range.end === null
            ? 'end'
            : 'start';
};
export { calculateValue, extractDateFromValue, extractMultipleFromValue, extractRangeFromValue, extractFocusedDate, extractActiveRange };



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-dateinputs/dist/es/calendar/utils/index.js
// module id = 797
// module chunks = 93